<template>
    <form-input :error="error">
        <div class="col-xs-6 float-left" v-if="help_link">
            <app-label :for="id">{{ label }}
                <template v-if="isRequired"><span class="asterisk">*</span></template>
            </app-label>
        </div>
        <div class="col-xs-6 float-right" v-if="help_link" v-html="help_link"></div>
        <app-label :for="id" v-else-if="label">{{ label }}
            <template v-if="isRequired"><span class="asterisk">*</span></template>
        </app-label>

        <iconed-input-field
            :type="type"
            :id="id"
            :placeholder="placeholder"
            :value="value"
            :name="name"
            :accept="accept"
            :max="max"
            :min="min"
            :autocomplete="autocomplete"
            :is-required="isRequired"
            :is-disabled="isDisabled"
            :is-readonly="isReadonly"
            @input="onInput"
            @focus="onFocus"
            @focusout="onFocusOut"
            @onEnter="onEnter"
        >
            <status-icon v-if="iconState" :type="iconState"/>
        </iconed-input-field>

        <help-block :text="error"/>
    </form-input>
</template>

<script>
    export default {
        props: {
            label: String,
            error: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            autocomplete: {
                type: String,
                default: 'off'
            },
            name: String,
            isRequired: {
                type: Boolean,
                default: false
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            isReadonly: {
                type: Boolean,
                default: false
            },
            id: String,
            value: String,
            iconState: {
                type: String,
                default: null
            },
            type: {
                type: String,
                default: 'text'
            },
            accept: String,
            help_link: {
                type: String,
                default: ''
            },
            min: {
                type: [Number, String]
            },
            max: {
                type: [Number, String]
            }
        },
        methods: {
            onInput(value) {
                this.$emit('input', value);
            },
            onFocus(value) {
                this.$emit('focus', value);
            },
            onFocusOut(value) {
                this.$emit('focusout', value);
            },
            onEnter(e) {
                this.$emit('onEnter', e);
            },
        }
    }
</script>
